import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import Footer from "../components/Footer";
import "./order.css";

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [selected, setSelected] = useState(null);
  const [status, setStatus] = useState("");
  const [viewOrder, setViewOrder] = useState(null);

  /* ================= FETCH ORDERS ================= */
  const fetchOrders = async () => {
    try {
      const res = await fetch("http://localhost:5000/api/orders");
      const data = await res.json();
      setOrders(Array.isArray(data.orders) ? data.orders : []);
    } catch (err) {
      console.error("Fetch orders failed", err);
      setOrders([]);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  /* ================= UPDATE ORDER ================= */
  const updateOrder = async () => {
    if (!selected) return;

    try {
      await fetch(`http://localhost:5000/api/orders/${selected._id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ status }),
      });

      setSelected(null);
      setStatus("");
      fetchOrders();
    } catch {
      alert("Update failed");
    }
  };

  /* ================= DELETE ORDER ================= */
  const deleteOrder = async (id) => {
    if (!window.confirm("Delete this order?")) return;

    try {
      await fetch(`http://localhost:5000/api/orders/${id}`, {
        method: "DELETE",
      });
      fetchOrders();
    } catch {
      alert("Delete failed");
    }
  };

  /* ================= VIEW SINGLE ORDER ================= */
  const viewSingleOrder = async (id) => {
    try {
      const res = await fetch(`http://localhost:5000/api/orders/${id}`);
      const data = await res.json();

      if (data.order) {
        setViewOrder(data.order);
      }
    } catch (err) {
      console.error("View order failed", err);
    }
  };

  return (
    <div className="admin-body">
      <Topbar />
      <Sidebar />

      <main className="admin-main">
        <h1 style={{ color: "#374151" }}>Order Management</h1>

        {/* ================= DESKTOP TABLE ================= */}
        <div className="table-card">
          <table className="data-table">
            <thead>
              <tr>
                <th>Customer</th>
                <th>Total</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {orders.length === 0 ? (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center" }}>
                    No orders found
                  </td>
                </tr>
              ) : (
                orders.map((o) => (
                  <tr key={o._id}>
                    <td>{o.customer?.name || "Customer"}</td>
                    <td>₹{o.total}</td>
                    <td>
                      <span className={`status ${o.status}`}>
                        {o.status}
                      </span>
                    </td>
                    <td>
                      <div className="action-buttons">
                        <button
                          className="action-btn edit-btn"
                          onClick={() => {
                            setSelected(o);
                            setStatus(o.status);
                          }}
                        >
                          ✏️
                        </button>

                        <button
                          className="action-btn delete-btn"
                          onClick={() => deleteOrder(o._id)}
                        >
                          🗑
                        </button>

                        <button
                          className="action-btn view-btn"
                          onClick={() => viewSingleOrder(o._id)}
                        >
                          👁
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* ================= MOBILE CARDS ================= */}
        <div className="mobile-orders">
          {orders.map((o) => (
            <div className="order-card" key={o._id}>
              <div className="row">
                <span>Customer</span>
                <strong>{o.customer?.name || "Customer"}</strong>
              </div>

              <div className="row">
                <span>Total</span>
                <strong>₹{o.total}</strong>
              </div>

              <div className="row">
                <span>Status</span>
                <span className={`status ${o.status}`}>{o.status}</span>
              </div>

              <div className="actions">
                <button onClick={() => {
                  setSelected(o);
                  setStatus(o.status);
                }}>✏️</button>

                <button onClick={() => deleteOrder(o._id)}>🗑</button>

                <button onClick={() => viewSingleOrder(o._id)}>👁</button>
              </div>
            </div>
          ))}
        </div>
      </main>

      {/* ================= VIEW DRAWER ================= */}
      <div className={`drawer ${viewOrder ? "open" : ""}`}>
        {viewOrder && (
          <div className="drawer-content">
            <h2>Order Details</h2>
            <p><b>Customer:</b> {viewOrder.customer?.name}</p>
            <p><b>Email:</b> {viewOrder.customer?.email}</p>
            <p><b>Status:</b> {viewOrder.status}</p>

            <h3>Items</h3>
            {(viewOrder.items || []).map((item, i) => (
              <div key={i}>
                {item.productName} — ₹{item.price} × {item.qty}
              </div>
            ))}

            <h3>Total: ₹{viewOrder.total}</h3>

            <button className="danger" onClick={() => setViewOrder(null)}>
              Close
            </button>
          </div>
        )}
      </div>

      {/* ================= UPDATE DRAWER ================= */}
      <div className={`drawer ${selected ? "open" : ""}`}>
        {selected && (
          <div className="drawer-content">
            <h2>Update Order</h2>

            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="pending">pending</option>
              <option value="completed">completed</option>
              <option value="cancelled">cancelled</option>
            </select>

            <div className="drawer-actions">
              <button className="primary" onClick={updateOrder}>
                Update
              </button>
              <button className="danger" onClick={() => setSelected(null)}>
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}
